import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waGeneral } from "@/lib/whatsapp";

export default function FloatingWhatsApp() {
  return (
    <motion.a href={waGeneral()} target="_blank" rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      initial={{ opacity: 0, scale: 0, y: 30 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 2, type: "spring", stiffness: 200, damping: 15 }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-5 right-5 z-50 flex items-center gap-3 bg-[#25D366] text-white border-2 border-ink rounded-full pl-4 pr-5 py-3 shadow-neo">
      <span className="relative flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-60" />
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
      </span>
      <MessageCircle size={22} strokeWidth={2.5} />
      <span className="font-bold text-sm leading-tight hidden sm:block">
        En línea<br /><span className="font-medium text-xs opacity-90">Cotizá tu pedido</span>
      </span>
    </motion.a>
  );
}
